import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hub-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
